<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="part-1-life">
<div class="section level2" id="the-polish-neighbours">
<h2>1. The Polish Neighbours</h2>
<p style="text-indent:0em;">It wasn’t until years later,</p>
<p style="text-indent:0em;">revisiting the neighbourhood,</p>
<p style="text-indent:0em;">I learned they were Poles –</p>
<p style="text-indent:0em;">at the time, they were just</p>
<p style="text-indent:0em;">the funny couple down the road</p>
<p style="text-indent:0em;">who’d been in the war</p>
<p style="text-indent:0em;">and had no kids.</p>
<br/>
<p style="text-indent:0em;">From a cubby house,</p>
<p style="text-indent:0em;">precariously perched at the top</p>
<p style="text-indent:0em;">of next door’s Moreton Bay,</p>
<p style="text-indent:0em;">(an old Homebush swamp raft</p>
<p style="text-indent:0em;">lugged all the way</p>
<p style="text-indent:0em;">in shifts over several months,</p>
<p style="text-indent:0em;">hoisted high with Egyptian flair,</p>
<p style="text-indent:0em;">it clung to the high swaying branches</p>
<p style="text-indent:0em;">magnificently…)</p>
<p style="text-indent:0em;">they could be seen doing nothing –</p>
<p style="text-indent:0em;">sitting,</p>
<p style="text-indent:0em;">occasionally talking briefly,</p>
<p style="text-indent:0em;">quietly,</p>
<p style="text-indent:0em;">a touch to the cheek,</p>
<p style="text-indent:0em;">a stroke of hair,</p>
<p style="text-indent:0em;">looking at each other,</p>
<p style="text-indent:0em;">things my parents never did –</p>
<p style="text-indent:0em;">I was too young, too preoccupied</p>
<p style="text-indent:0em;">dodging Messerschmidt tracers</p>
<p style="text-indent:0em;">to recognize love tinged with quiet despair.</p>
<br/>
<p style="text-indent:0em;">They always said hello,</p>
<p style="text-indent:0em;">came down to the fence</p>
<p style="text-indent:0em;">and said how well my mother looked after me,</p>
<p style="text-indent:0em;">enquired about school, about me,</p>
<p style="text-indent:0em;">not the other kids, just me.</p>
<br/>
<p style="text-indent:0em;">Over seven years,</p>
<p style="text-indent:0em;">I’d be spruced up by Mum,</p>
<p style="text-indent:0em;">for a formal visit just ‘to please’.</p>
<p style="text-indent:0em;">Inside their house,</p>
<p style="text-indent:0em;">foreign music drifted through small rooms,</p>
<p style="text-indent:0em;">curtains drawn,</p>
<p style="text-indent:0em;">rows of candles in silver holders,</p>
<p style="text-indent:0em;">little hats…</p>
<br/>
<p style="text-indent:0em;">strange,</p>
<p style="text-indent:0em;">but oh, the food –</p>
<p style="text-indent:0em;">so different from snags with sauce and vinegar chips,</p>
<p style="text-indent:0em;">consistencies, flavours smooth as song</p>
<p style="text-indent:0em;">on my untutored tongue</p>
<p style="text-indent:0em;">as to be magic,</p>
<p style="text-indent:0em;">and honeyed morsels</p>
<p style="text-indent:0em;">which caked my teeth like fragrant wet cement.</p>
<br/>
<p style="text-indent:0em;">All for me</p>
<p style="text-indent:0em;">and each time a small gift –</p>
<p style="text-indent:0em;">a coin, a pen set, a small book of verse;</p>
<p style="text-indent:0em;">I was a favoured and loved child,</p>
<p style="text-indent:0em;">doted on so much by them,</p>
<p style="text-indent:0em;">cloying, all sweetness,</p>
<p style="text-indent:0em;">so happy,</p>
<p style="text-indent:0em;">so sad.</p>
<br/>
<p style="text-indent:0em;">The wife died</p>
<p style="text-indent:0em;">suddenly.</p>
<p style="text-indent:0em;">All went quiet.</p>
<p style="text-indent:0em;">The neighbourhood said in whispers,</p>
<p style="text-indent:0em;">“He won’t last.”</p>
<p style="text-indent:0em;">He didn’t –</p>
<p style="text-indent:0em;">sick, out of sight,</p>
<p style="text-indent:0em;">he stayed six months</p>
<p style="text-indent:0em;">then was buried beside his wife.</p>
<br/>
<p style="text-indent:0em;">I started high school</p>
<p style="text-indent:0em;">and forgot.</p>
<br/>
<p style="text-indent:0em;">I forgot until that revisit when a neighbour,</p>
<p style="text-indent:0em;">matronly and giving and kind in her own right,</p>
<p style="text-indent:0em;">reminded me of my grandfather’s name –</p>
<p style="text-indent:0em;">Ezekiel Hyem.</p>
<br/>
<p style="text-indent:0em;">The Polish neighbours</p>
<p style="text-indent:0em;">with their unpronounceable, unspellable names</p>
<p style="text-indent:0em;">were my parents,</p>
<p style="text-indent:0em;">and I,</p>
<p style="text-indent:0em;">their inconceivable child.</p>
</div>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Section0001.vue?0fc586d0